import {useApp} from "../../app.context";
import BooleanInput from "../../elements/booleanInput.element";

function SettingsEditorView() {
    const {showIds, setShowIds} = useApp();

    return (
        <div className={'layout horizontal box flex-grow stretch'} style={{gap: 10}}>
            <div className={'layout vertical gap'} style={{width: 500, gap: 20}}>
                <p className={'text header'}>Editor Settings</p>
                <div className={'layout vertical gap box'} style={{padding: 16, gap: 12}}>
                    <div className={'layout horizontal center gap'}>
                        <BooleanInput value={showIds} onChange={setShowIds}/>
                        <div className={'layout vertical'}>
                            <p>Show IDs</p>
                            <p style={{color: 'var(--muted-text-color)', fontSize: 13}}>
                                Display the underlying id on attribute rows. Useful when writing code that references attributes; not usually needed for content design.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SettingsEditorView;
